// extracted by mini-css-extract-plugin
export default {"scoreSelectFormGroup":"score-table-dynamic-cell__score-select-form-group__XGvtB"};